// extracted by mini-css-extract-plugin
export var progressBar = "_ng-0";
export var progressBarInner = "_ng-1";